var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperienceExpertsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2935 78.8619H13.9648V59.3344C17.0537 55.6531 21.6024 53.5375 26.4049 53.5375H27.0608C30.9536 53.5375 34.7406 54.6165 38.0622 56.6263L40.6433 58.1919H53.1681C55.8761 58.1919 58.0764 60.3922 58.0764 63.1003C58.0764 65.8083 55.8761 68.0086 53.1681 68.0086H36.8775H53.295C54.3951 68.0086 55.4741 67.6066 56.2992 66.8873L73.3726 52.2046C74.6632 51.1045 76.4615 50.8506 78.0059 51.5487C80.8198 52.797 81.4968 56.4782 79.3176 58.6574L64.4234 73.5516C61.0172 76.9578 56.405 78.8619 51.6025 78.8619H27.2935Z",
    stroke: "#005350",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12581 53.7911H12.3769C13.2443 53.7911 13.9636 54.5105 13.9636 55.3779V78.8617C13.9636 79.7292 13.2443 80.4485 12.3769 80.4485H4.12581C3.25839 80.4485 2.53906 79.7292 2.53906 78.8617V55.3779C2.53906 54.5105 3.25839 53.7911 4.12581 53.7911Z",
    stroke: "#005350",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4375 25.8012V37.3315C24.4375 37.7124 24.6279 38.072 24.9453 38.2836L36.9834 46.1115C38.6124 47.1694 40.7281 47.1694 42.3572 46.1115L54.3953 38.2836C54.7126 38.072 54.903 37.7124 54.903 37.3315V25.8012",
    stroke: "#005350",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7422 18.3327L39.6689 2.38061L67.5957 18.3327L39.6689 34.2848L11.7422 18.3327Z",
    fill: "#EA7F4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7422 18.3327L39.6689 2.38061L67.5957 18.3327L39.6689 34.2848L11.7422 18.3327Z",
    stroke: "#EA7F4A",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7891 44.4613H71.4054V31.3019C71.4054 29.2074 69.6918 27.4937 67.5973 27.4937C65.5027 27.4937 63.7891 29.2074 63.7891 31.3019V44.4613Z",
    stroke: "#005350",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4961 18.4808C36.4961 16.7248 37.9136 15.3073 39.6696 15.3073C41.4256 15.3073 42.8431 16.7248 42.8431 18.4808C42.8431 20.2368 41.4256 21.6543 39.6696 21.6543C37.9136 21.6543 36.4961 20.2368 36.4961 18.4808Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4961 18.4808C36.4961 16.7248 37.9136 15.3073 39.6696 15.3073C41.4256 15.3073 42.8431 16.7248 42.8431 18.4808C42.8431 20.2368 41.4256 21.6543 39.6696 21.6543C37.9136 21.6543 36.4961 20.2368 36.4961 18.4808Z",
    stroke: "#EA7F4A",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.597 26.6261V18.3327H42.8438",
    stroke: "#005350",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceExpertsIcon);
export default __webpack_public_path__ + "static/media/experience-experts-icon.23f48e92df5f378ca9f467bb3835aee0.svg";
export { ForwardRef as ReactComponent };